
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type SearchPageHeaderRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchPageHeaderRT(): TemplateResult<SearchPageHeaderRTRootProps> {
    return !this.isLoading ? _createElement('span', {
        'className': 'cm_search-page_heading',
        'key': '0'
    }, '\n  Results', this.responseQuery ? ` for "${ this.responseQuery }"` : '', this.isVehicleSelected ? ` for your "${ window.Convermax.getVehicleStringWithoutQualifires(window.Convermax.getVehicle()) }"` : '', '\n') : null;
}
        export const componentNames = []